import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=3cb7d259&scoped=true&"
import script from "./userAvatar.vue?vue&type=script&lang=js&"
export * from "./userAvatar.vue?vue&type=script&lang=js&"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=3cb7d259&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7d259",
  null
  
)

export default component.exports